// Full-screen paper loader shown while the session hydrates on boot.

export function LoadingScreen() {
  return (
    <div className="paper-grain flex min-h-dvh flex-col items-center justify-center gap-4">
      <div
        className="h-10 w-10 animate-spin rounded-full border-[3px] border-citrus/30 border-t-citrus"
        aria-hidden
      />
      <p className="stamp text-sm text-ink-muted">Finding the farm road…</p>
    </div>
  );
}
